
import { messageBus } from "@/utils/a2a/communication/messageBus";
import type { Activity } from "../ActivityTypes";
// Corrected imports from @/utils/a2a/types based on its actual exports
import type { A2AMessage, IntentType, UrgencyLevel, A2AMessageMetadata, MessageType } from "@/utils/a2a/types";

// Define a more specific metadata structure for activity-related messages, if needed.
interface ActivityCustomMetadata extends Partial<Omit<A2AMessageMetadata, 'intent' | 'priority' | 'messageType'>> {
  activityId?: string;
  activityType?: Activity['type'];
  activityCount?: number;
  tabSelected?: "today" | "tomorrow";
  error?: string;
  [key: string]: any; 
}

/**
 * Publishes a message to the A2A message bus, specifically for activity-related events.
 *
 * @param intent The intent of the message (e.g., 'activity-started', 'data-refresh').
 * @param content A descriptive string human-readable content of the message.
 * @param customMetadata Additional metadata specific to the activity event.
 * @param urgency The urgency level of the message.
 */
export const publishA2AMessage = (
  intent: IntentType,
  content: string,
  customMetadata?: ActivityCustomMetadata,
  urgencyLevel?: UrgencyLevel
) => {
  
  const metadataPayload: A2AMessageMetadata = { 
    protocol: 'A2A', // Default protocol
    version: '1.1', // Default version
    messageType: 'NOTIFICATION' as MessageType, // Default message type, adjust if needed
    timestamp: new Date().toISOString(),
    intent: intent,
    ...customMetadata, 
  };

  if (urgencyLevel) {
    metadataPayload.priority = urgencyLevel;
  }
  
  // Construct the full A2AMessage object to be published
  // Ensure A2AMessage properties like id, signature, keyId are handled by the publisher or are optional for creation
  const messageToPublish: Partial<A2AMessage> & { fromAgent: string; toAgent: string; content: string; metadata: A2AMessageMetadata } = {
    fromAgent: 'activities-service',
    toAgent: '*', 
    content: content,
    metadata: metadataPayload,
  };
  
  messageBus.publish(messageToPublish as A2AMessage); // Cast as A2AMessage, assuming publish handles missing fields like id

  // console.log(`A2A Message Published [${intent}]: ${content}`, metadataPayload);
};

